<template>
    <button class="secondary-button" @click="onClick" :data-is-active="isActive" :disabled="disabled" :data-variant="variant">
        <slot name="icon"></slot>
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'secondaryButton',
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            default: 'solid' // 'solid' | 'outline'
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>

<style scoped>

.secondary-button {
    appearance: none;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing);
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 500;
    background-color: var(--color-light-blue);
    color: var(--color-white);
    border: 1px solid var(--color-light-blue);
    border-radius: var(--radius-md);
    transition: all 0.2s ease;
    cursor: pointer;
    user-select: none;
    opacity: 1;
}

.secondary-button[data-variant="outline"] {
    background-color: transparent;
    border: 1px solid var(--border-primary);
    color: var(--color-primary);
}

.secondary-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.secondary-button:hover:not(:disabled) {
    opacity: 0.8;
}

.secondary-button:active:not(:disabled) {
    scale: 0.98;
}

.secondary-button[data-is-active="true"] {
    background-color: var(--color-primary);
    color: var(--color-white);
}
</style>